<template>
  <NuxtNotifications
    position="top center"
    :width="'100%'"
    :speed="300"
    :duration="5000"
  >
    <template #body="{ item, close }">
      <div
        :class="item.type"
        class="vue-notification"
      >
        <img
          :src="`/svg/notify/${iconNotify(item.type)}.svg`"
          class="mr-4"
        />
        <div class="flex flex-row justify-between items-center w-full">
          <p class="title">
            {{ item.text }}
          </p>
          <button
            class="p-2 cursor-pointer"
            @click="close"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.2958 9.85045C12.2958 9.59933 12.1953 9.34821 12.0145 9.16741L9.06138 6.21429L12.0145 3.26116C12.1953 3.08036 12.2958 2.82924 12.2958 2.57812C12.2958 2.32701 12.1953 2.07589 12.0145 1.89509L10.6484 0.529017C10.4676 0.348214 10.2165 0.247767 9.9654 0.247767C9.71429 0.247767 9.46317 0.348214 9.28237 0.529017L6.32924 3.48214L3.37612 0.529017C3.19531 0.348214 2.9442 0.247767 2.69308 0.247767C2.44196 0.247767 2.19085 0.348214 2.01004 0.529017L0.643973 1.89509C0.46317 2.07589 0.362723 2.32701 0.362723 2.57812C0.362723 2.82924 0.46317 3.08036 0.643973 3.26116L3.5971 6.21429L0.643973 9.16741C0.46317 9.34821 0.362723 9.59933 0.362723 9.85045C0.362723 10.1016 0.46317 10.3527 0.643973 10.5335L2.01004 11.8996C2.19085 12.0804 2.44196 12.1808 2.69308 12.1808C2.9442 12.1808 3.19531 12.0804 3.37612 11.8996L6.32924 8.94643L9.28237 11.8996C9.46317 12.0804 9.71429 12.1808 9.9654 12.1808C10.2165 12.1808 10.4676 12.0804 10.6484 11.8996L12.0145 10.5335C12.1953 10.3527 12.2958 10.1016 12.2958 9.85045Z"
                fill="#FF2742"
                fill-opacity="0.797979"
              />
            </svg>
          </button>
        </div>
      </div>
    </template>
  </NuxtNotifications>
</template>

<script>
export default {
  name: 'Notification',
  methods: {
    iconNotify (type) {
      if (type === 'error' || type === 'success' || type === 'warn') {
        return type
      } else {
        return 'info'
      }
    },
  },
}
</script>
